import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

export default function BigScreenSlider() {
  if (document.querySelector('.big-screen-slider .swiper')) {
    // eslint-disable-next-line no-new
    new Swiper('.big-screen-slider .swiper', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: true,
      lazy: true,
      draggable: true,
      pagination: {
        el: '.big-screen-slider .swiper-pagination',
        clickable: true,
        renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
      },
      autoplay: {
        enabled: true,
        delay: 6000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.bigslider-swiper-button-next',
        prevEl: '.bigslider-swiper-button-prev',
      },
    });
  }
}
